import type { FC } from 'react';

import styles from './CheckAnimation.module.css';

export const CheckAnimation: FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path className={styles.circle} strokeWidth="2" d="M9.5 2.5a7 7 0 1 1 0 14 7 7 0 0 1 0-14Z" />
      <path className={styles.check} strokeWidth="2" d="m5.931 9.382 2.51 2.499 4.778-4.76" />
    </svg>
  );
};
